import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SearchIcon from "@mui/icons-material/Search";
import {
  Backdrop,
  Box,
  Button,
  Fade,
  FormControl,
  IconButton,
  InputLabel,
  Modal,
  TextField,
  Typography,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  ListItemText,
  OutlinedInput,
  CircularProgress,
  Tooltip,
  InputAdornment,
  Grid,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  DataGrid,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  useGridApiRef,
} from "@mui/x-data-grid";
import FilterAlt from "@mui/icons-material/FilterAlt";
//import Frm from '../../pages/Frm';
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { getReport } from "../../redux/actions/reportAction";
import Close from "@mui/icons-material/Close";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import PlayArrow from "@mui/icons-material/PlayArrow";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import GetAppIcon from "@mui/icons-material/GetApp";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import socketIOClient from "socket.io-client";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import RecordingCell from "../common/RecordingCell";
import PageTitle from "../common/PageTitle";
import {
  usePersistedColumnVisibility,
  usePersistedColumnWidths,
  usePersistedColumnOrder,
  usePersistedDensity,
  buildColumnVisibilityKey,
} from "../common/usePersistedColumnVisibility";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "../../Switcher.scss";

import { getAllUsers } from "../../redux/actions/userAction";
import { makeStyles } from "@mui/styles";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { DateTimePicker } from "@mui/x-date-pickers";

dayjs.extend(utc);
dayjs.extend(timezone);
const drawerWidth = 240;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const useStyles = makeStyles({
  borderedGreen: {
    borderLeft: "3px solid green", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  borderedRed: {
    borderLeft: "3px solid red", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  formControl: {
    "& .MuiInputBase-root": {
      color: "#666",
      borderColor: "transparent",
      borderWidth: "1px",
      borderStyle: "solid",
      height: "45px",
      minWidth: "120px",
      justifyContent: "center",
    },
    "& .MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px",
    },
    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
      top: "-4px",
    },
  },
  select: {
    width: "auto",
    fontSize: "12px",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  selectIcon: {
    position: "relative",
    color: "#6EC177",
    fontSize: "14px",
  },
  paper: {
    borderRadius: 12,
    marginTop: 8,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    "& li": {
      fontWeight: 200,
      paddingTop: 8,
      paddingBottom: 8,
      fontSize: "12px",
    },
    "& li.Mui-selected": {
      color: "white",
      background: "#6EC177",
    },
    "& li.Mui-selected:hover": {
      background: "#6EC177",
    },
  },
});

const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-row": {
            minHeight: "auto", // Adjust row height to make it more compact
          },
        },
      },
      defaultProps: {
        density: "compact", // Set default density to compact
        exportButton: true,
      },
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarDensitySelector />
    </GridToolbarContainer>
  );
}

// =====Start Items====>

// =====End Items====>

function ResellerReport({ colorThem }) {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const [currentAudio, setCurrentAudio] = useState(null);
  const [userId, setUserId] = useState("");
  const railwayZone = "Asia/Kolkata"; // Replace with your desired timezone
  const [fromDate, setFromDate] = useState(
    dayjs().tz(railwayZone).startOf("day").format("DD/MM/YYYY HH:mm")
  );
  const [toDate, setToDate] = useState(
    dayjs().tz(railwayZone).endOf("day").format("DD/MM/YYYY HH:mm")
  );
  const [callDirection, setCallDirection] = useState("");
  const [didNumber, setDidNumber] = useState("");
  const [destination, setDestination] = useState("");
  const [response, setResponse] = useState("");
  const audioRefs = useRef({}); // Store references to audio elements
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [val, setVal] = useState(false);
  const [durationOp, setDurationOp] = useState(">=");
  const [durationValue, setDurationValue] = useState("");
  const [uniqueOnly, setUniqueOnly] = useState(false);
  const prefKey = buildColumnVisibilityKey("reseller");
  const [columnVisibilityModel, setColumnVisibilityModel] =
    usePersistedColumnVisibility(prefKey);
  const [savedWidths, handleColumnWidthChange] = usePersistedColumnWidths(prefKey);
  const { applyOrder, handleOrderChange } = usePersistedColumnOrder(prefKey, apiRef);
  const { density: savedDensity, handleStateChange: handleDensityStateChange } =
    usePersistedDensity(prefKey, "compact");
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
  };

  const classes = useStyles();

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    classes: {
      list: classes.list,
      paper: classes.paper,
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    getContentAnchorEl: null,
  };

  const handleFromDateChange = (date) => {
    if (dayjs(date, "DD/MM/YYYY HH:mm", true).isValid()) {
      setFromDate(dayjs(date).tz(railwayZone).format("DD/MM/YYYY HH:mm"));
    } else {
      setFromDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (dayjs(date, "DD/MM/YYYY HH:mm", true).isValid()) {
      setToDate(dayjs(date).tz(railwayZone).format("DD/MM/YYYY HH:mm"));
    } else {
      setToDate(null);
    }
  };
  useEffect(() => {
    let data = JSON.stringify({
      from_date: dayjs().format("YYYY-MM-DD"),
      to_date: dayjs().format("YYYY-MM-DD"),
    });
    dispatch(getReport(data));
    dispatch(getAllUsers(""));
  }, [dispatch, response]);

  const handleSearch = (e) => {
    // Convert fromDate and toDate to YYYY-MM-DD format
    const formattedFromDate = fromDate
      ? dayjs(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : null;
    const formattedToDate = toDate
      ? dayjs(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : null;
    let data = JSON.stringify({
      from_date: formattedFromDate,
      to_date: formattedToDate,
      call_direction: callDirection,
      did_number: didNumber,
      destination: destination,
    });
    dispatch(getReport(data));
  };

  const handleReset = (e) => {
    setFromDate(
      dayjs().tz(railwayZone).startOf("day").format("DD/MM/YYYY HH:mm")
    );
    setToDate(
      dayjs().tz(railwayZone).endOf("day").format("DD/MM/YYYY HH:mm")
    );
    setUserId("");
    setCallDirection("");
    setDidNumber("");
    setDestination("");
    setDurationOp(">=");
    setDurationValue("");
    setUniqueOnly(false);
    setResponse("data");
  };

  // Function to handle audio clicks
  const handleAudioClick = (audioSrc) => {
    const audio = audioRefs.current[audioSrc];
    // const audio = document.getElementById(audioSrc);
    // Check if the clicked audio is already the current audio
    if (currentAudio === audio) {
      // Toggle play/pause
      if (audio.pause) {
        audio.play();
      } else {
        audio.pause();
      }
    } else {
      // If a different audio is clicked, pause the current audio (if any) and play the new one
      if (currentAudio) {
        currentAudio.pause();
      }
      setCurrentAudio(audio);
      audio.play();
    }
  };

  const handleAudioPause = () => {
    //  setCurrentAudio(null);
  };

  const handleDownload = (recordingPath) => {
    // You can implement download logic here
    // For example, create a link with the recording path and click it programmatically
    const link = document.createElement("a");
    link.href = recordingPath;
    link.download = recordingPath.split("/").pop(); // Set filename to the last part of the path
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = [
    {
      field: "caller_id_number",
      headerName: "Caller ID",
      headerClassName: "custom-header-redirect",
      width: 110,
      headerAlign: "center",
      align: "center",
      cellClassName: "super-app-theme--cell",
    },
    {
      field: "did_tfn",
      headerName: "DID Number",
      width: 110,
      headerClassName: "custom-header-redirect",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "forwarded_number",
      headerName: "Forwarded Number",
      width: 110,
      headerClassName: "custom-header-redirect",
      headerAlign: "center",
      align: "center",
    },

    {
      field: "hangup_reason",
      headerName: "Status",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header",
    },
    {
      field: "call_status",
      headerName: "Call Status",
      width: 150,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header",
    },
    {
      field: "buyer_name",
      headerName: "Buyer Name",
      minWidth: 130,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header",
      renderCell: (params) => (
        <Tooltip title={params.value || ""} arrow>
          <span style={{ whiteSpace: "nowrap" }}>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "campaign_name",
      headerName: "Campaign Name",
      minWidth: 130,
      headerClassName: "custom-header-redirect",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title={params.value || ""} arrow>
          <span style={{ whiteSpace: "nowrap" }}>{params.value}</span>
        </Tooltip>
      ),
    },
    
    {
      field: "duration",
      headerName: "Duration",
      width: 60,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header-redirect",
    },
    {
      field: "recording_path",
      headerName: "Recording",
      width: 95,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header-redirect",
      renderCell: (params) => {
        if (params.row.billsec >= 0) {
          return (
            <RecordingCell
              src={params.row.recording_path}
              audioControls={{
                registerAudioRef: (s, el) => {
                  if (el) audioRefs.current[s] = el;
                },
                handleAudioClick,
                handleAudioPause,
              }}
            />
          );
        }
        return <></>;
      },
    },
    {
      field: "answer_at",
      headerName: "Call Answer Time",
      width: 160,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header-redirect",
      //valueFormatter
      renderCell: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          var day = date.getUTCDate();
          var month = date.getUTCMonth() + 1; // Month starts from 0
          var year = date.getUTCFullYear();
          var hours = date.getUTCHours();
          var minutes = date.getUTCMinutes();
          var seconds = date.getUTCSeconds();

          // Formatting single-digit day/month with leading zero if needed
          day = (day < 10 ? "0" : "") + day;
          month = (month < 10 ? "0" : "") + month;

          // Formatting single-digit hours/minutes/seconds with leading zero if needed
          hours = (hours < 10 ? "0" : "") + hours;
          minutes = (minutes < 10 ? "0" : "") + minutes;
          seconds = (seconds < 10 ? "0" : "") + seconds;
          return (
            <>
              <span className="cdr-date-part">
                {day}/{month}/{year}
              </span>
              &nbsp;
              <span className="cdr-time-part">
                {hours}:{minutes}:{seconds}
              </span>
            </>
          );
        }
      },
    },

    {
      field: "start_at",
      headerName: "Call Start Time",
      width: 160,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header-redirect",
      renderCell: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          var day = date.getUTCDate();
          var month = date.getUTCMonth() + 1; // Month starts from 0
          var year = date.getUTCFullYear();
          var hours = date.getUTCHours();
          var minutes = date.getUTCMinutes();
          var seconds = date.getUTCSeconds();

          // Formatting single-digit day/month with leading zero if needed
          day = (day < 10 ? "0" : "") + day;
          month = (month < 10 ? "0" : "") + month;

          // Formatting single-digit hours/minutes/seconds with leading zero if needed
          hours = (hours < 10 ? "0" : "") + hours;
          minutes = (minutes < 10 ? "0" : "") + minutes;
          seconds = (seconds < 10 ? "0" : "") + seconds;
          return (
            <>
              <span className="cdr-date-part">
                {day}/{month}/{year}
              </span>
              &nbsp;
              <span className="cdr-time-part">
                {hours}:{minutes}:{seconds}
              </span>
            </>
          );
        }
      },
    },

    {
      field: "end_at",
      headerName: "Call End Time",
      width: 160,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header-redirect",
      renderCell: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          var day = date.getUTCDate();
          var month = date.getUTCMonth() + 1; // Month starts from 0
          var year = date.getUTCFullYear();
          var hours = date.getUTCHours();
          var minutes = date.getUTCMinutes();
          var seconds = date.getUTCSeconds();

          // Formatting single-digit day/month with leading zero if needed
          day = (day < 10 ? "0" : "") + day;
          month = (month < 10 ? "0" : "") + month;

          // Formatting single-digit hours/minutes/seconds with leading zero if needed
          hours = (hours < 10 ? "0" : "") + hours;
          minutes = (minutes < 10 ? "0" : "") + minutes;
          seconds = (seconds < 10 ? "0" : "") + seconds;

          return (
            <>
              <span className="cdr-date-part">
                {day}/{month}/{year}
              </span>
              &nbsp;
              <span className="cdr-time-part">
                {hours}:{minutes}:{seconds}
              </span>
            </>
          );
        }
      },
    },

    {
      field: "uniqueid",
      headerName: "Unique Id",
      width: 180,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header-redirect",
    },
  ];

  const orderedColumns = applyOrder(columns);

  // Function to determine whether a row should have the bordered style
  const isRowBordered = (params) => {
    const { row } = params;

    // Add your condition here, for example, adding border to rows where age is greater than 25
    return row.disposition === "ANSWERED";
  };

  const rows = [];

  // Canvas-based column sizing — bypass MUI autosize (it under-measures due
  // to style.css's global .MuiDataGrid-cellContent { font-size: 12px } rule
  // while cells render at 14px via our !important sx).
  useEffect(() => {
    if (!apiRef.current || !rows?.length) return;
    const t = setTimeout(() => {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const headerFont = '700 14px "Roboto","Helvetica","Arial",sans-serif';
        const cellFont = '400 14px "Roboto","Helvetica","Arial",sans-serif';

        const minimums = {};

        // Widget / fixed-format columns — skip canvas, use fixed width.
        // Date columns render "DD/MM/YYYY HH:MM:SS" regardless of raw ISO.
        const fixedWidths = {
          recording_path: 140,
          start_at: 145,
          end_at: 145,
          answer_at: 145,
        };

        // IMPORTANT: spread full column def — updateColumns REPLACES entries
        // for listed fields. Passing only {field, width} strips renderCell
        // and all formatting.
        const cols = apiRef.current.getAllColumns();
        const updates = cols.map((col) => {
          // MUI's built-in selection checkbox column — force a compact fixed
          // size and block resizing so it can't drift wider over time.
          if (col.field === "__check__") {
            return {
              ...col,
              width: 52,
              minWidth: 52,
              maxWidth: 52,
              resizable: false,
            };
          }
          // User's manually-resized width (persisted) wins over canvas/fixed.
          const savedW = savedWidths[col.field];
          if (savedW) {
            return {
              ...col,
              width: savedW,
              maxWidth: Math.max(savedW, 400),
            };
          }
          if (fixedWidths[col.field]) {
            return {
              ...col,
              width: fixedWidths[col.field],
              maxWidth: 400,
            };
          }

          ctx.font = headerFont;
          let maxW = ctx.measureText(String(col.headerName || "")).width;

          ctx.font = cellFont;
          for (const row of rows) {
            const raw = row?.[col.field];
            if (raw == null) continue;
            const w = ctx.measureText(String(raw)).width;
            if (w > maxW) maxW = w;
          }

          const baseMin = minimums[col.field] || 60;
          const computedWidth = Math.max(baseMin, Math.ceil(maxW) + 20);
          return {
            ...col,
            width: computedWidth,
            // Override hardcoded maxWidth so canvas-measured width isn't clamped.
            maxWidth: Math.max(computedWidth, 400),
          };
        });

        apiRef.current.updateColumns(updates);
      } catch (_) { /* grid not ready */ }
    }, 100);
    return () => clearTimeout(t);
  }, [rows.length, apiRef, savedWidths]);
  state?.report?.report?.data &&
    state?.report?.report?.data?.forEach((item, index) => {
      rows.push({
        id: index + 1,
        did_tfn: item.tfn_number,
        destination_number: item.service_type,
        uniqueid: item.uniqueid,
        caller_id_number: item.clid,
        user_uuid: item?.user_uuid,
        call_direction: item?.call_direction,
        disposition: item?.disposition,
        duration: item?.duration,
        billsec: item?.billsec,
        answer_at: item.answer_at,
        time: item.answer_at,
        end_at: item.end_at,
        start_at: item.start_at,
        start_time: item.start_at,
        end_at: item.end_at,
        recording_path: item.recording_path,
        hangup_reason: item.status,
        call_status: item.call_status,
        destination_type: item.destination_type,
        destination: item.destination,
        username: item.username,
        answered_by: item.answered_by,
      });
    });

  // Client-side filters (duration + dedupe-by-uniqueid) — separate from the
  // server-side search payload.
  const durationThreshold =
    durationValue !== "" && !Number.isNaN(Number(durationValue))
      ? Number(durationValue)
      : null;
  const durationFiltered =
    durationThreshold === null
      ? rows
      : rows.filter((row) => {
          const d = Number(row.duration);
          if (Number.isNaN(d)) return false;
          switch (durationOp) {
            case "=":  return d === durationThreshold;
            case "!=": return d !== durationThreshold;
            case "<":  return d < durationThreshold;
            case "<=": return d <= durationThreshold;
            case ">":  return d > durationThreshold;
            case ">=":
            default:   return d >= durationThreshold;
          }
        });
  let filteredRows = durationFiltered;
  if (uniqueOnly) {
    // Dedupe by caller_id_number — first occurrence wins. Collapses rows
    // sharing the same caller. Empty caller_id_number passes through.
    const seen = new Set();
    const out = [];
    for (const row of durationFiltered) {
      const key = row.caller_id_number;
      if (key == null || key === "") {
        out.push(row);
        continue;
      }
      if (!seen.has(key)) {
        seen.add(key);
        out.push(row);
      }
    }
    filteredRows = out;
  }

  return (
    <>
      <div className={`App ${colorThem} `}>
        <div className="contant_box">
          <Box
            className="right_sidebox mobile_top_pddng"
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="">
                    {/* <!----> */}
                    <div className="tab-content" id="pills-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        {/* <!--role-contet--> */}

                        <Box sx={{ maxWidth: "1340px", mx: "auto", width: "100%" }}>
                        <div className="cntnt_title">
                          <div className="col-12">
                            <PageTitle title="Call Details Records" />
                          </div>
                        </div>

                        <Box
                          className="cdr_filter_row"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 0.75,
                            py: 1,
                          }}
                        >
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            gap: 0.75,
                          }}
                        >
                          <Box
                            sx={{ display: "flex", alignItems: "center", flex: "1 1 150px", minWidth: 140, maxWidth: 200 }}
                          >
                            <FormControl
                              fullWidth
                              style={{ width: "98%", margin: "7px 0" }}
                              className={classes.formControl}
                            >
                              <InputLabel id="demo-simple-select-label">
                                UserName
                              </InputLabel>

                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="UserName"
                                helperText="Select the language."
                                style={{ textAlign: "left" }}
                                value={userId}
                                onChange={(e) => {
                                  setUserId(e.target.value);
                                }}
                                required
                              >
                                {state?.allUsers?.users?.map((item, index) => {
                                  return (
                                    <MenuItem key={index} value={item?.id}>
                                      {item.username}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Box>
                          <Box
                            sx={{ display: "flex", alignItems: "center", flex: "1 1 150px", minWidth: 140, maxWidth: 200 }}
                          >
                            <TextField
                              className={classes.formControl}
                              style={{
                                width: "98%",
                                margin: " 5px 0 5px 0",
                              }}
                              type="text"
                              label="Caller Number"
                              variant="outlined"
                            />
                          </Box>
                          <Box
                            sx={{ display: "flex", alignItems: "center", flex: "1 1 150px", minWidth: 140, maxWidth: 200 }}
                          >
                            <TextField
                              className={classes.formControl}
                              style={{
                                width: "98%",
                                margin: " 5px 0 5px 0",
                              }}
                              type="text"
                              label="Extension"
                              variant="outlined"
                            />
                          </Box>
                          <Box
                            sx={{ display: "flex", alignItems: "center", gap: 0.5, flex: "0 0 auto" }}
                          >
                            <TextField
                              select
                              size="small"
                              label="Op"
                              variant="outlined"
                              value={durationOp}
                              onChange={(e) => setDurationOp(e.target.value)}
                              sx={{
                                width: 72,
                                margin: "5px 0",
                                "& .MuiInputBase-root": { minWidth: 0, height: 40, fontSize: 14 },
                                "& .MuiInputLabel-root": { fontSize: 14 },
                              }}
                            >
                              <MenuItem value="=">=</MenuItem>
                              <MenuItem value="!=">≠</MenuItem>
                              <MenuItem value="<">&lt;</MenuItem>
                              <MenuItem value="<=">≤</MenuItem>
                              <MenuItem value=">">&gt;</MenuItem>
                              <MenuItem value=">=">≥</MenuItem>
                            </TextField>
                            <TextField
                              size="small"
                              type="number"
                              label="Sec"
                              variant="outlined"
                              value={durationValue}
                              onChange={(e) => setDurationValue(e.target.value)}
                              inputProps={{ min: 0, maxLength: 3 }}
                              sx={{
                                width: 88,
                                margin: "5px 0",
                                "& .MuiInputBase-root": { minWidth: 0, height: 40, fontSize: 14 },
                                "& .MuiInputLabel-root": { fontSize: 14 },
                              }}
                            />
                          </Box>
                          <Box
                            sx={{ display: "flex", alignItems: "center", flex: "0 0 auto", px: 0.5 }}
                          >
                            <Tooltip title="Show only unique rows by Caller ID" arrow>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={uniqueOnly}
                                    onChange={(e) => setUniqueOnly(e.target.checked)}
                                  />
                                }
                                label="Unique"
                                sx={{
                                  m: 0,
                                  "& .MuiFormControlLabel-label": { fontSize: 13, fontWeight: 500 },
                                }}
                              />
                            </Tooltip>
                          </Box>
                          <Box
                            sx={{ display: "flex", alignItems: "center", flex: "1 1 150px", minWidth: 140, maxWidth: 200 }}
                          >
                            <TextField
                              className={classes.formControl}
                              style={{
                                width: "98%",
                                margin: " 5px 0 5px 0",
                              }}
                              type="text"
                              label="DID Number"
                              variant="outlined"
                              value={didNumber}
                              onChange={(e) => {
                                setDidNumber(e.target.value);
                              }}
                            />
                          </Box>
                          <Box
                            sx={{ display: "flex", alignItems: "center", flex: "1 1 150px", minWidth: 140, maxWidth: 200 }}
                          >
                            <TextField
                              className={classes.formControl}
                              style={{
                                width: "98%",
                                margin: " 5px 0 5px 0",
                              }}
                              type="text"
                              label="Destination Number"
                              variant="outlined"
                              value={destination}
                              onChange={(e) => {
                                setDestination(e.target.value);
                              }}
                            />
                          </Box>
                          <Box
                            sx={{ display: "flex", alignItems: "center", flex: "1 1 150px", minWidth: 140, maxWidth: 200 }}
                          >
                            <FormControl
                              className={classes.formControl}
                              fullWidth
                              style={{ width: "98%", margin: "7px 0" }}
                            >
                              <InputLabel id="demo-simple-select-label">
                                Call Direction
                              </InputLabel>

                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Call Direction"
                                helperText="Select the language."
                                style={{ textAlign: "left" }}
                                value={callDirection}
                                onChange={(e) => {
                                  setCallDirection(e.target.value);
                                }}
                                required
                              >
                                <MenuItem value={"Inbound"}>Inbound</MenuItem>
                                <MenuItem value={"Outbound"}>Outbound</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Box>

                        {/* Row 2: dates + action buttons */}
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            gap: 0.75,
                          }}
                        >
                          {/* <Grid xl={3} lg={3} md={3} sm={12} xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                          <FormControl
                              className={classes.formControl}
                              fullWidth
                              style={{ width: "98%", margin: "7px 0px" }}
                            >
                              <InputLabel id="demo-simple-select-label">
                                Status
                              </InputLabel>

                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Status"
                                helperText="Select the language."
                                style={{ textAlign: "left" }}
                              >
                                <MenuItem value={"FAILED"}>FAILED</MenuItem>
                                <MenuItem value={"BUSY"}>BUSY</MenuItem>
                                <MenuItem value={"NO ANSWER"}>
                                  NO ANSWER
                                </MenuItem>
                                <MenuItem value={"CONGESTION"}>
                                  CONGESTION
                                </MenuItem>
                                <MenuItem value={"ANSWERED"}>ANSWERED</MenuItem>
                              </Select>
                            </FormControl>
                          </Box> */}
                          <Box
                            sx={{ display: "flex", alignItems: "center", flex: "1 1 150px", minWidth: 140, maxWidth: 200 }}
                          >
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              className={classes.formControl}
                            >
                              <DemoContainer
                                components={["DatePicker"]}
                                sx={{ width: "98%" }}
                              >
                                <DateTimePicker
                                  label="From Date"
                                  value={
                                    fromDate
                                      ? dayjs(fromDate, "DD/MM/YYYY HH:mm")
                                      : null
                                  }
                                  onChange={handleFromDateChange}
                                  renderInput={(props) => (
                                    <TextField {...props} />
                                  )}
                                  format="DD/MM/YYYY HH:mm" // 24-hour format
                                  ampm={false} // Disables AM/PM toggle
                                  minutesStep={1}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </Box>
                          <Box
                            sx={{ display: "flex", alignItems: "center", flex: "1 1 150px", minWidth: 140, maxWidth: 200 }}
                          >
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              className={classes.formControl}
                            >
                              <DemoContainer
                                components={["DatePicker"]}
                                sx={{ width: "98%" }}
                              >
                                <DateTimePicker
                                  label="To Date"
                                  value={
                                    toDate
                                      ? dayjs(toDate, "DD/MM/YYYY HH:mm")
                                      : null
                                  }
                                  onChange={handleToDateChange}
                                  renderInput={(props) => (
                                    <TextField {...props} />
                                  )}
                                  format="DD/MM/YYYY HH:mm" // 24-hour format
                                  ampm={false} // Disables AM/PM toggle
                                  minutesStep={1} // Show all minutes (no step increment)
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              ml: "auto",
                              flexShrink: 0,
                            }}
                          >
                            <Button
                              variant="contained"
                              onClick={handleSearch}
                              startIcon={<SearchIcon sx={{ fontSize: 26 }} />}
                              size="small"
                              sx={{
                                background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
                                color: "#fff !important",
                                textTransform: "none",
                                fontSize: "13px !important",
                                fontWeight: 600,
                                height: 40,
                                padding: "4px 14px !important",
                                minWidth: 0,
                                whiteSpace: "nowrap",
                                borderRadius: "8px !important",
                                mr: 0.75,
                                boxShadow: "0 4px 12px rgba(22, 163, 74, 0.35)",
                                transition: "transform 0.15s ease, box-shadow 0.15s ease",
                                "&:hover": {
                                  background: "linear-gradient(135deg, #15803d 0%, #166534 100%)",
                                  transform: "translateY(-1px)",
                                  boxShadow: "0 6px 16px rgba(22, 163, 74, 0.45)",
                                },
                              }}
                            >
                              Apply Filters
                            </Button>
                            <Button
                              variant="contained"
                              onClick={handleReset}
                              startIcon={<RestartAltIcon sx={{ fontSize: 26 }} />}
                              size="small"
                              sx={{
                                background: "linear-gradient(135deg, #64748b 0%, #475569 100%)",
                                color: "#fff !important",
                                textTransform: "none",
                                fontSize: "13px !important",
                                fontWeight: 600,
                                height: 40,
                                padding: "4px 14px !important",
                                minWidth: 0,
                                whiteSpace: "nowrap",
                                borderRadius: "8px !important",
                                boxShadow: "0 4px 12px rgba(71, 85, 105, 0.35)",
                                transition: "transform 0.15s ease, box-shadow 0.15s ease",
                                "&:hover": {
                                  background: "linear-gradient(135deg, #475569 0%, #334155 100%)",
                                  transform: "translateY(-1px)",
                                  boxShadow: "0 6px 16px rgba(71, 85, 105, 0.45)",
                                },
                              }}
                            >
                              Reset
                            </Button>
                          </Box>
                        </Box>
                        </Box>

                        <ThemeProvider theme={theme}>
                          <div style={{ height: 620, width: "100%" }}>
                            <DataGrid
                              apiRef={apiRef}
                              rows={filteredRows}
                              columns={orderedColumns}
                              initialState={{ density: savedDensity }}
                              onStateChange={handleDensityStateChange}
                              columnVisibilityModel={columnVisibilityModel}
                              onColumnVisibilityModelChange={setColumnVisibilityModel}
                              onColumnWidthChange={handleColumnWidthChange}
                              onColumnOrderChange={handleOrderChange}
                              rowHeight={36}
                              columnHeaderHeight={36}
                              headerClassName="custom-header"
                              components={{ Toolbar: GridToolbar }}
                              sx={{
                                "& .MuiDataGrid-columnHeaders": {
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 99,
                                  backgroundColor: "#fff",
                                },
                                // Kill only the ellipsis — preserve per-cell
                                // fonts/colors/bold/hyperlinks/flex layouts.
                                // Canvas measurement + 40px buffer keeps text
                                // fitting cleanly.
                                "& .MuiDataGrid-cell, & .MuiDataGrid-cellContent": {
                                  textOverflow: "clip !important",
                                },
                                "& .MuiDataGrid-cell": {
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                },
                                "& .MuiDataGrid-filler, & .MuiDataGrid-columnHeader--filler, & .MuiDataGrid-scrollbarFiller, & .MuiDataGrid-scrollbarFiller--header, & .MuiDataGrid-scrollbarFiller--borderTop, & .MuiDataGrid-cell--filler, & .MuiDataGrid-row--filler": {
                                  display: "none !important",
                                },
                              }}
                            />
                          </div>
                        </ThemeProvider>
                        </Box>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
}

export default ResellerReport;
